const ROUTES = {};

ROUTES.ROOT = '/';

ROUTES.INTRO = '/#intro';
ROUTES.SERVICES = '/services'; //areas
ROUTES.PRODUCTS = '/#products';
ROUTES.CASES = '/cases';
ROUTES.GMP = '/gmp';
ROUTES.ABOUT = '/about';
ROUTES.CONTACTS = '/#contacts';
ROUTES.PRIVACY = '/privacy';
ROUTES.BLOG = '/blog';
ROUTES.JOBS = '/jobs';

export default ROUTES;
